import React from 'react';
import OfficeItem from '../Contents/Office/OfficeAdmin/OfficeItem';
import dateTimeHelper from '../Helpers/datetimeHelper';
import OfficeHelper from '../Helpers/ModelHelpers/OfficeHelper';
import AuthService from './authService';

class OfficeService extends React.Component {
  static GetOfficeDataById(officeId) {
    return AuthService.getInstance().CallBackendFunction(`/api/Office/GetOfficeDataById/${officeId}`);
  }

  static GetOfficeNameById(officeId) {
    return AuthService.getInstance().CallBackendFunction(`/api/Office/GetOfficeNameById/${officeId}?clearCache=false`);
  }

  static GetOfficeList() {
    return AuthService.getInstance().CallBackendFunction('/api/Office/GetOfficesWithPOCs');
  }

  // Offices (with their office group) change rarely, so the list is fetched once per page load and kept in
  // OfficeHelper, the only cache of it; every later call is answered from there.
  static GetOfficesForSelect() {
    if (OfficeHelper.IsLoaded()) {
      return Promise.resolve(OfficeHelper.GetOffices());
    }
    return OfficeService.LoadOfficesForSelect(false);
  }

  // Refreshes the cache after an office was saved on the Offices page (its name or office group may have changed).
  static ReloadOfficesForSelect() {
    return OfficeService.LoadOfficesForSelect(true);
  }

  static LoadOfficesForSelect(clearCache) {
    return AuthService.getInstance()
      .CallBackendFunction(`/api/Office/GetOfficesForSelectAsync?clearCache=${clearCache}`)
      .then((offices) => {
        OfficeHelper.SetOffices(offices);
        return OfficeHelper.GetOffices();
      });
  }

  static GetOfficeGroups() {
    return AuthService.getInstance().CallBackendFunction('/api/Office/GetOfficeGroupsAsync?clearCache=true');
  }

  static GetOfficesByReportRole() {
    const user = AuthService.getInstance().GetLoggedInUser();
    return AuthService.getInstance().CallBackendFunction(`/api/Office/GetOfficesByReportRoleAsync/${user.userId}`);
  }

  static GetOfficeGlobalData() {
    return AuthService.getInstance().CallBackendFunction('/api/Office/GetOfficeGlobalData');
  }

  static ConvertDBEvaluator(items) {
    const convertedItems = [];

    if (items !== null) {
      items.forEach((item) => {
        const newItem = new OfficeItem(item);
        convertedItems.push(newItem);
      });
    }

    return convertedItems;
  }

  static EditOffice(office) {
    office = OfficeService.ConvertAllPropertyToString(office);

    const officeJSON = JSON.stringify(office);
    return AuthService.getInstance().CallBackendFunctionPut('/api/Office/EditOffice', officeJSON);
  }

  static EditGlobalOffice(office) {
    office = OfficeService.ConvertAllPropertyToString(office);

    const officeJSON = JSON.stringify(office);
    return AuthService.getInstance().CallBackendFunctionPut('/api/Office/EditGlobalOffice', officeJSON);
  }

  static MissedInvoicesEmailNotification() {
    return AuthService.getInstance().CallBackendFunction(
      '/api/MissedInvoiceNotification/SendMissedInvoicesNotificationAsync'
    );
  }

  static ConvertAllPropertyToString(office) {
    for (const key in office) {
      if (
        key == 'HighValueReportGroupId' ||
        key == 'UninvoicedShopsReportGroupId' ||
        key == 'MissedInvoiceNotificationGroupId' ||
        key == 'PaymentOfficeIds' ||
        key == 'mysteryShoppingPlatformPricings' ||
        key == 'callRecordingCosts' ||
        key == 'csatcosts' ||
        key == 'ivrcosts'
      )
        continue;
      if (Object.hasOwnProperty.call(office, key)) {
        office[key] = !office[key] ? '' : office[key].toString();
      }
    }
    office.TipaltiFromDate = dateTimeHelper.toYYYYsMMsDD(office.TipaltiFromDate);
    return office;
  }

  static EditFreelancerInvoiceContacts(editItem) {
    const editItemJSON = JSON.stringify(editItem);
    return AuthService.getInstance().CallBackendFunctionPut(
      '/api/OfficeContact/EditFreelancerInvoiceContactsAsync',
      editItemJSON
    );
  }

  static GetPaymentOffices(officeId) {
    return AuthService.getInstance().CallBackendFunction(
      `/api/Office/GetPaymentOfficesAsync/${officeId}?clearCache=true`
    );
  }

  static GetOfficeBillingCurrency(officeId, clearCache = false) {
    return AuthService.getInstance().CallBackendFunction(
      `/api/Office/GetOfficeBillingCurrency/${officeId}?clearCache=${clearCache}`
    );
  }

  static GetOfficeEmployeeCostGroupSettings(officeId) {
    return AuthService.getInstance().CallBackendFunction(
      `/api/OfficeEmployeeCostGroupSettings/GetOfficeEmployeeCostGroupSettings/${officeId}`
    );
  }

  static EditOfficeEmployeeCostGroupSettings(resource) {
    const json = JSON.stringify(resource);
    return AuthService.getInstance().CallBackendFunctionPut(
      '/api/OfficeEmployeeCostGroupSettings/EditOfficeEmployeeCostGroupSettings',
      json
    );
  }
}

export default OfficeService;
